import React from 'react';

import { getFormattedDate } from '../../../../utils/date';
import { useOrganizationMemberDetailsContext } from '../context/OrganizationMemberDetailsContext';
import * as Style from './style.module.scss';

const VacationHeaderNote: React.FC = () => {
    const { memberDetails } = useOrganizationMemberDetailsContext();

    if (
        memberDetails.vacation_details?.status !== 'vacation_started' ||
        !memberDetails.vacation_details?.user_configured_start_datetime ||
        !memberDetails.vacation_details?.user_configured_end_datetime
    ) {
        return null;
    }

    return (
        <div className={`${Style.wrapper}`}>
            <strong>Travelling / Away from home</strong>
            <strong>
                {getFormattedDate(
                    new Date(memberDetails.vacation_details.user_configured_start_datetime),
                    'MMM d, yyyy'
                )}{' '}
                -{' '}
                {getFormattedDate(
                    new Date(memberDetails.vacation_details.user_configured_end_datetime),
                    'MMM d, yyyy'
                )}
            </strong>
        </div>
    );
};

export default VacationHeaderNote;
